/*
 * Copyright (c) 2020. © MAGEGUIDE. All Rights Reserved.
 */

import { Field } from 'Util/Query';

class ContactUsFormQuery {

    getContactUsFormQuery(options){
        let input = ['input','ContactusInput!',options];
        return new Field('contactusFormSubmit')
            .addArgument(...input)
            .addField('success_message');
    }
}

export default new ContactUsFormQuery();
